import AB from "@/assets/images/picto-commercial/AB.svg";
import aop from "@/assets/images/picto-commercial/aop.svg";
import igp from "@/assets/images/picto-commercial/igp.svg";
import label_rouge from "@/assets/images/picto-commercial/label_rouge.svg";
import mdd_ame_terroir from "@/assets/images/picto-commercial/mdd_ame_terroir.svg";
import mdd_cora from "@/assets/images/picto-commercial/mdd_cora.svg";
import mdd_degustation from "@/assets/images/picto-commercial/mdd_degustation.svg";
import mdd_domeos from "@/assets/images/picto-commercial/mdd_domeos.svg";
import mdd_influx from "@/assets/images/picto-commercial/mdd_influx.svg";
import mdd_influx_basic from "@/assets/images/picto-commercial/mdd_influx_basic.svg";
import mdd_nature_bio from "@/assets/images/picto-commercial/mdd_nature_bio.svg";
import mdd_optimalp from "@/assets/images/picto-commercial/mdd_optimalp.svg";
import mdd_patrimoine_gourmand from "@/assets/images/picto-commercial/mdd_patrimoine_gourmand.svg";
import mdd_verciel from "@/assets/images/picto-commercial/mdd_verciel.svg";
import pictoEnergieAvenir from "@/assets/images/picto-commercial/picto-energie-avenir.svg";
import prd_bio from "@/assets/images/picto-commercial/prd_bio.svg";
import prd_surg from "@/assets/images/picto-commercial/prd_surg.svg";

import carrefour from "@/assets/images/picto-commercial/carrefour.png"
import carrefourBio from "@/assets/images/picto-commercial/carrefour-bio.png";
import carrefourBonAppetit from "@/assets/images/picto-commercial/carrefour-bon-appetit@2x.png";
import carrefourClassic from "@/assets/images/picto-commercial/carrefour-classic@2x.png";
import carrefourCompanino from "@/assets/images/picto-commercial/carrefour-companino@2x.png";
import carrefourEcoPlanet from "@/assets/images/picto-commercial/carrefour-eco-planet@2x.png";
import carrefourEssential from "@/assets/images/picto-commercial/carrefour-essential@2x.png";
import carrefourExpert from "@/assets/images/picto-commercial/carrefour-expert@2x.png";
import carrefourExtra from "@/assets/images/picto-commercial/carrefour-extra@2x.png";
import carrefourLeMarche from "@/assets/images/picto-commercial/carrefour-le-marche@2x.png";
import carrefourMen from "@/assets/images/picto-commercial/carrefour-men@2x.png";
import carrefourOriginal from "@/assets/images/picto-commercial/carrefour-original@2x.png";
import carrefourSelection from "@/assets/images/picto-commercial/carrefour-selection@2x.png";
import carrefourSensationVegetal from "@/assets/images/picto-commercial/carrefour-sensation-vegetal@2x.png";
import carrefourSensation from "@/assets/images/picto-commercial/carrefour-sensation@2x.png";
import carrefourSoftBio from "@/assets/images/picto-commercial/carrefour-soft-bio@2x.png";
import carrefourSoftGreen from "@/assets/images/picto-commercial/carrefour-soft-green@2x.png";
import carrefourSoftMiniS from "@/assets/images/picto-commercial/carrefour-soft-mini-s@2x.png";
import carrefourSoft from "@/assets/images/picto-commercial/carrefour-soft@2x.png";
import deNuestraTierra from "@/assets/images/picto-commercial/de-nuestra-tierra@2x.png";
import espritDeFete from "@/assets/images/picto-commercial/esprit-de-fete@2x.png";
import filiereQualiteCarrefour from "@/assets/images/picto-commercial/filiere-qualite-carrefour@2x.png";
import lesBelges from "@/assets/images/picto-commercial/les-belges@2x.png";
import lesProduitsCarrefour from "@/assets/images/picto-commercial/les-produits-carrefour@2x.png";
import nectarOfBio from "@/assets/images/picto-commercial/nectar-of-bio@2x.png";
import polskaGoscina from "@/assets/images/picto-commercial/polska-goscina@2x.png";
import refletDeFrance from "@/assets/images/picto-commercial/reflet-de-france@2x.png";
import science from "@/assets/images/picto-commercial/science@2x.png";
import simpl from "@/assets/images/picto-commercial/simpl@2x.png";
import terreDItalia from "@/assets/images/picto-commercial/terre-d-italia@2x.png";

export const commercialPictos = {
  AB,
  aop,
  igp,
  label_rouge,
  mdd_ame_terroir,
  mdd_cora,
  mdd_degustation,
  mdd_domeos,
  mdd_influx,
  mdd_influx_basic,
  mdd_nature_bio,
  mdd_optimalp,
  mdd_patrimoine_gourmand,
  mdd_verciel,
  "picto-energie-avenir": pictoEnergieAvenir,
  prd_bio,
  prd_surg,
  carrefour,
  "carrefour-bio": carrefourBio,
  "carrefour-bon-appetit": carrefourBonAppetit,
  "carrefour-classic": carrefourClassic,
  "carrefour-companino": carrefourCompanino,
  "carrefour-eco-planet": carrefourEcoPlanet,
  "carrefour-essential": carrefourEssential,
  "carrefour-expert": carrefourExpert,
  "carrefour-extra": carrefourExtra,
  "carrefour-le-marche": carrefourLeMarche,
  "carrefour-men": carrefourMen,
  "carrefour-original": carrefourOriginal,
  "carrefour-selection": carrefourSelection,
  "carrefour-sensation-vegetal": carrefourSensationVegetal,
  "carrefour-sensation": carrefourSensation,
  "carrefour-soft-bio": carrefourSoftBio,
  "carrefour-soft-green": carrefourSoftGreen,
  "carrefour-soft-mini-s": carrefourSoftMiniS,
  "carrefour-soft": carrefourSoft,
  "de-nuestra-tierra": deNuestraTierra,
  "esprit-de-fete": espritDeFete,
  "filiere-qualite-carrefour": filiereQualiteCarrefour,
  "les-belges": lesBelges,
  "les-produits-carrefour": lesProduitsCarrefour,
  "nectar-of-bio": nectarOfBio,
  "polska-goscina": polskaGoscina,
  "reflet-de-france": refletDeFrance,
  "terre-d-italia": terreDItalia,
  science,
  simpl
}

export const commercialPictosTypes = Object.keys(commercialPictos);